module.exports = __webpack_public_path__ + "static/media/des-icon-1.af49e539.svg";